import railsData from '../../../../../../utilities/rails-data';

export function prefilledData(key) {
  return railsData(`prefilledData.${key}`);
}
